import React, { useEffect, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../../components/styled/Elements";
import { ResetPassWrapper } from "./styled";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { Col, Form, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import { ResetPasswordImg } from "../../../components/styled/AllImages";
import { useTranslation } from "react-i18next";
import AuthWelcome from "../../../components/auth/AuthWelcomeCol";
import { LoginWrapper } from "../styled";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthApi from "../../../services/api/authApi";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const [isLoading, setIsLoading] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(true);
  const [isVisible, setIsVisible] = useState(window.innerWidth >= 992);
  const handleReset = async (data) => {
    const obj = {
      ...data,
      email,
      token,
    };
    try {
      setIsLoading(true);
      const response = await AuthApi.resetPassword(obj);
      if (response.code === 200) {
        toast.success(t("password_changed_successfully"));
        navigate("/login");
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const handelResize = () => {
      setIsVisible(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handelResize);
    return () => {
      window.removeEventListener("resize", handelResize);
    };
  }, []);

  const checkToken = async () => {
    try {
      const { code, message } = await AuthApi.checkResetToken({ email, token });
      if (code === 200) {
        setIsTokenValid(true);
      }
      if (code === 100 || code === 204) {
        setIsTokenValid(false);
      }
    } catch (error) {
      if (error) {
        setIsTokenValid(false);
      }
    }
  };

  useEffect(() => {
    if (email && token) checkToken();
  }, [email, token]);

  return (
    <LoginWrapper>
      <AuthHeader />
      <Box className="container-fluid containerAuth">
        <Row>
          <Col
            lg={6}
            md={12}
            sm={12}
            className="px-3 px-xl-5 overflow-y-auto authCol"
          >
            <Box className="logSignInner">
              {isTokenValid ? (
                <Box>
                  <Box className="mb-4">
                    <HeadingStyled size="24px">
                      {t("Resetyourpassword")}
                    </HeadingStyled>
                    <TextStyled>{t("Createpasswordsecureremember")}</TextStyled>
                  </Box>
                  <Form onSubmit={handleSubmit(handleReset)}>
                    <Box>
                      <ValidatedInput
                        name="password"
                        label={"new_password"}
                        type="input"
                        fieldType="password"
                        placeholder={"newPasswordPlaceholder"}
                        register={register}
                        errors={errors}
                        validationRules={{
                          required: true,
                        }}
                        className={"mb-4 combined flex-wrap p-0"}
                        bg="var(--white)"
                      />
                      <ValidatedInput
                        name="password_confirmation"
                        label={"confirm_new_password"}
                        type="input"
                        fieldType="password"
                        placeholder={"confirmNewPasswordPlaceholder"}
                        register={register}
                        errors={errors}
                        validationRules={{
                          required: true,
                          validate: (value) =>
                            value === watch("password") ||
                            "password_do_not_match",
                        }}
                        className={"mb-3 combined flex-wrap p-0"}
                        bg="var(--white)"
                      />
                      <FormButtonStyled
                        label={t("CreateNewPassword")}
                        type="submit"
                        color="var(--white)"
                        bg="var(--themeColor)"
                        className="w-100"
                        clName="w-100 my-4"
                        isLoading={isLoading}
                      />
                    </Box>
                  </Form>
                </Box>
              ) : (
                <Box>
                  <Box className="mt-5">
                    <HeadingStyled size="34px">
                      {t("you_are_unable_to_change_password")}
                    </HeadingStyled>
                    <TextStyled
                      size="20px"
                      className="mt-4"
                      color="var(--darkGrey)"
                    >
                      {t("token_expired_or_something_went_wrong")}
                    </TextStyled>
                  </Box>
                </Box>
              )}
            </Box>
          </Col>
          {isVisible && (
            <AuthWelcome logSignImg={ResetPasswordImg} noBorderClass={true} />
          )}
        </Row>
      </Box>
    </LoginWrapper>
  );
};

export default ResetPassword;
